import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { MainLoader } from "CommonComponent";

const AuthLayout = () => {
  return (
    <>
      <div className="auth-layout">
        <div className="auth-container">
          <Suspense fallback={<div>Loading Authentication...</div>}>
            <Outlet />
          </Suspense>
        </div>
      </div>
      <MainLoader/>
    </>
  );
};

export default AuthLayout;
